import './AdminHeaderBar.scss'

interface AdminHeaderBarProps {
  title: string
  onMenuClick?: () => void
}

const AdminHeaderBar = ({ title, onMenuClick }: AdminHeaderBarProps) => {
  return (
    <header className='bx-admin-header'>
      <div className='bx-admin-header__left'>
        <button
          type='button'
          className='bx-admin-header__menu-btn'
          aria-label='Open navigation menu'
          onClick={onMenuClick}
        >
          <span />
          <span />
          <span />
        </button>
        <h2 className='bx-admin-header__title'>{title}</h2>
      </div>
      <div className='bx-admin-header__right'>
        <div className='bx-admin-header__date'>
          {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </div>
      </div>
    </header>
  )
}

export default AdminHeaderBar
